var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"song-release-progress"},[_vm._v("已发布"+_vm._s(_vm.usageCount)+"首（限制提交"+_vm._s(_vm.trackLimitCount)+"首） ")])
}
var staticRenderFns = []

export { render, staticRenderFns }